// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var TicketHeader$ReactHooksTemplate = require("./ticketHeader.res.js");

function defaultColumnOrder(headers) {
  var core = [
    "id",
    "priority",
    "status",
    "assignee"
  ];
  var df = Belt_List.toArray(Belt_List.keepMap(Belt_List.map(headers, (function (h) {
                  var id = DataField$ReactHooksTemplate.id(TicketHeader$ReactHooksTemplate.dataField(h));
                  if (id !== undefined) {
                    return "df_" + String(id);
                  }
                  
                })), (function (x) {
              return x;
            })));
  var tail = ["created_at"];
  return Belt_Array.concatMany([
              core,
              df,
              tail
            ]);
}

function resolveColumnOrder(headers, order) {
  if (order.length === 0) {
    return defaultColumnOrder(headers);
  } else {
    return order;
  }
}

exports.defaultColumnOrder = defaultColumnOrder;
exports.resolveColumnOrder = resolveColumnOrder;
/* DataField-ReactHooksTemplate Not a pure module */
